 <!-- /.content-wrapper -->
 <footer class="main-footer">
  <strong>Copyright &copy; 2023-2024 <a href="www.plvglobal.com">PLV Technologies Private Limited </a>.</strong>
  All rights reserved.
  <div class="float-right d-none d-sm-inline-block">
    <b>Version</b> 3.2.0
  </div>
</footer>

